import { MouseEventHandler, useCallback } from 'react';
import { useIntl } from 'react-intl';

import Close from '@mui/icons-material/Close';
import { Dialog, DialogProps, IconButton } from '@mui/material';

import styled from 'styled-components';

export const PortfolioDialog = styled(({ children, onClose, ...rest }: DialogProps) => {
  const intl = useIntl();

  const handleCloseButtonOnClick: MouseEventHandler = useCallback(
    (event) => onClose?.(event, 'escapeKeyDown'),
    [onClose]
  );

  return (
    <Dialog {...rest} onClose={onClose}>
      {children}
      <IconButton
        aria-label={intl.formatMessage({ id: 'close-dialog', defaultMessage: 'Close Dialog' })}
        className="close-button"
        onClick={handleCloseButtonOnClick}
      >
        <Close />
      </IconButton>
    </Dialog>
  );
})`
  .MuiPaper-root {
    padding: ${({ theme }) => theme.spacing(4, 8)};
    min-width: 495px;
  }

  .MuiDialogTitle-root {
    text-align: center;
  }

  .close-button {
    position: absolute;
    top: ${({ theme }) => theme.spacing(1)};
    right: ${({ theme }) => theme.spacing(1)};
  }
`;
